import React from 'react'
import './App.css';
import { Route, Routes, Outlet } from 'react-router-dom';
import Layout from './components/shared/Layout/Layout';
import SelectHubPage from './pages/SelectHubPage';
import HomePage from './pages/HomePage';
import EditOrder from './components/Orders/EditOrder/EditOrder'
import SupplyList from './components/Supplies/SupplyList/SupplyList';

function App() {
  return (
    <Routes>
      <Route element={<Layout isGeneric={true}><Outlet /></Layout>}>
        <Route path="/Home/SelectHub/:code" element={<SelectHubPage />} />
      </Route>
      <Route element={<Layout isGeneric={false} hideTabs={true}><Outlet /></Layout>}>
        <Route element={<EditOrder><Outlet /></EditOrder>}>
          <Route path="/SupplyList/:orderId/:orderName/:orderStatus" element={<SupplyList />} />
        </Route>
        <Route path="*" element={<HomePage />} />
      </Route>

    </Routes>
  );
}

export default App;
